import { useResource } from 'app';
import { provinces } from 'helpers/statics/provinces';

function useProvinces() {
  return provinces;
}

function useEventCategories() {
  return useResource('category', 'collection', '/categories?include=children');
}

export { useEventCategories, useProvinces };
